import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useRealtimeFrame, useRealtimeStatus } from '../../shared/api/realtime';
import { listIssues, viewCount } from './api';

const FALLBACK_QUERY_KEY = ['issues', 'sidebar'];

// `undefined` means no badge, never zero: an uncomputed count is not a nil.
export const useIssueCountLiveUpdate = ({ enabled }: { enabled: boolean }): number | undefined => {
  const status = useRealtimeStatus();
  const [pushed, setPushed] = useState<number | undefined>(undefined);

  useRealtimeFrame('counters', (frame) => setPushed(frame.counters.issues));

  useEffect(() => {
    if (status !== 'live') setPushed(undefined);
  }, [status]);

  const fed = status === 'live' && pushed !== undefined;

  const fallback = useQuery({
    queryKey: FALLBACK_QUERY_KEY,
    queryFn: () => listIssues({ view: 'active', limit: 1 }),
    enabled: enabled && !fed,
    staleTime: 30_000,
  });

  return pushed ?? viewCount(fallback.data?.counts, 'active');
};
